import { Component } from '@angular/core';
import { ModalService } from 'src/app/core/services/modal.service';
import { MigrationNoticeComponent } from '../migration-notice/migration-notice.component';

@Component({
  selector: 'app-migration-banner',
  templateUrl: './migration-banner.component.html',
  styleUrls: ['./migration-banner.component.scss'],
})
export class MigrationBannerComponent {
  constructor(private modalService: ModalService) {}

  openMigrationPopup() {
    this.modalService.openModal(MigrationNoticeComponent, {
      height: 'auto',
      width: '1000px',
      data: {
        migrationDate: '29/07/2025',
        blocageDate: '24/07/2025',
      },
      disableClose: true,
    });
  }
}
